import React, {FC} from 'react';
import {formatDateUtcToLocal} from '../../../utils/formFormatterUtils';

type Props = {
    date: string;
}

const UtcToLocalTime:FC<Props> = ({date}) => <>{formatDateUtcToLocal(date).toString()}</>

export default UtcToLocalTime;